import { BellIcon } from '@phosphor-icons/react'
import type { NodeProps } from '@xyflow/react'
import type { SendNotificationFlowNode } from 'app/types/workflows'
import { NodeShell } from './NodeShell'

/** Sends an internal notification (email or in-app) to a team member. */
export function SendNotificationNode({ data, selected }: NodeProps<SendNotificationFlowNode>) {
  const channel = data.channel === `email` ? `Email` : data.channel === `in_app` ? `In-app` : `Email + in-app`
  return (
    <NodeShell
      icon={BellIcon}
      accent="pink"
      kind="Notify"
      label={data.label}
      description={`${channel} notification`}
      selected={selected}
    />
  )
}
